export type MeshDeviceState = {
    meshgatewayLoading: boolean;
    meshgatewaySuccess: boolean;
    loading: boolean;
    success: boolean;
    errorCode: string;
    hasData: boolean;

};
export const initialMeshDevice: MeshDeviceState = {
    meshgatewayLoading: false,
    meshgatewaySuccess: false,
    loading: false,
    success: false,
    errorCode: '',
    hasData: true,

};
